import React, { useEffect, useState } from "react";
import API from "../Service/Baseservice";
import "../Admin/Admin.css";
import { useNavigate } from "react-router-dom";
import AdminView from "../../Assets/img/Eye.svg";
import AdminEdit from "../../Assets/img/Edit.svg";
import AdminDelete from "../../Assets/img/Delete.svg";
import Loading from "../../Loading/loading";
import human from "../../Assets/img/Icon.png";

const Admin = () => {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const navigate = useNavigate();

    // ✅ Fetch Admin List
    const fetchAdmins = () => {
        setLoading(true);
        API.post("admin_list/condition")
            .then((response) => {
                const allAdmins = response.data?.data?.data || [];
                const activeAdmins = allAdmins.filter((a) => a.active !== 4);
                setAdmins(activeAdmins);
            })
            .catch((err) => {
                console.error("Error fetching admins:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchAdmins();
    }, []);


    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowPopup(true);
    };

    const confirmDelete = () => {
        if (!deleteId) return;
        API.post("admin_delete/update", { admin_id: deleteId, active: 4 })
            .then(() => {
                setShowPopup(false);
                setDeleteId(null);
                fetchAdmins();
            })
            .catch((err) => {
                console.error("Failed to delete admin:", err);
                alert("Failed to delete admin.");
            });
    };

    return (
        <div className="admin-container">
            <div className="news-header">
                <h2 className="news-title">Admin List</h2>
                <button className="add-btn" onClick={() => navigate("/adminadd")}>
                    + Add Admin
                </button>
            </div>

            {/* Admin Table */}
            <div className="admin-table-wrapper">
                {loading ? (
                    <Loading />
                ) : (
                    <table className="admin-table ">
                        <thead>
                            <tr>
                                <th>Admin Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th >Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        {admins.length > 0 ? (
                            <tbody>
                                {admins.map((admin) => (
                                    <tr key={admin.admin_id}>
                                        <td className="admin-info-cell">
                                            <img
                                                className="icon-img"
                                                src={admin.admin_image ? admin.admin_image : human}
                                                alt="Admin"
                                                onError={(e) => (e.target.src = human)}
                                            />
                                            <span className="admin-name">{admin.admin_name}</span>
                                        </td>
                                        <td>{admin.email}</td>
                                        <td>{admin.phone_number}</td>
                                        <td>
                                            <span className={`badge status-badge ${admin.active === 1 ? "text-bg-success" : "text-bg-danger"}`} style={{ fontSize: "14px" }}>
                                                {admin.active === 1 ? "Active" : "Inactive"}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="action-buttons">
                                                {/* Hide Edit/Delete for Super Admin */}
                                                {admin.admin_id !== 1 && (
                                                    <>
                                                        <img
                                                            src={AdminView}
                                                            alt="View"
                                                            className="admin-icon-btn"
                                                             data-tooltip="View"
                                                            onClick={() =>
                                                                navigate(`/adminview/${admin.admin_id}`, {
                                                                    state: { adminData: admin },
                                                                })
                                                            }
                                                        />
                                                        <img
                                                            src={AdminEdit}
                                                            alt="Edit"
                                                            className="admin-icon-btn"
                                                             data-tooltip="Edit"
                                                            onClick={() =>
                                                                navigate(`/adminedit/${admin.admin_id}`, {
                                                                    state: { adminData: admin },
                                                                })
                                                            }
                                                        />
                                                        <img
                                                            src={AdminDelete}
                                                            alt="Delete"
                                                            className="admin-icon-btn"
                                                             data-tooltip="Delete"
                                                            onClick={() => handleDeleteClick(admin.admin_id)}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No admin found.
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                )}
            </div>

            {/* Delete Confirmation Popup */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3>Confirm Delete</h3>
                        <p>Are you sure you want to delete this admin?</p>
                        <div className="popup-buttons">
                            <button className="cancel-btn " onClick={() => setShowPopup(false)}>
                                Cancel
                            </button>
                            <button className="btn delete-btn" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Admin;
